<template>
  <div class="add-invoice">
    <add-form-new :key="$route.params.value" />
  </div>
</template>
<script>
import AddFormNew from '@/components/invoices/Add/AddFormNew'
import { freshdeskMixin } from '@/mixins/Freshdesk'

export default {
  errorCaptured: function (err) {
    console.log('Caught error', err.message)
  },
  mounted() {
    document.title = 'Add Invoice | Drip Portal'
    this.$mpTrack('Add invoice page mounted')
    if (this.$store.state.account.country === 'India') {
      this.showAndPrefillFreshdesk({ cf_category_i: 'Invoice related' })
    }
  },
  components: {
    AddFormNew
  },
  mixins: [freshdeskMixin],
  beforeCreate() {
    const toDashboard =
      this.$store.getters.ddpCheck === 0 ||
      !this.$store.getters.hasInvoiceAddAndCreatePermission()
    /**
       * ?: below is the old access roles code
        return (
          this.$store.getters.hasPermission('esign') ||
          this.$store.getters.hasPermission('edit')
        )
       **/

    if (toDashboard) {
      this.$router.push('/')
    }
  }
}
</script>
